<script setup lang="ts">
import CheckIcon from '@/components/base/assets/CheckIcon.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import SmallBodyText from '@/components/base/typography/SmallBodyText.vue';
import UnstyledButton from '@/components/base/UnstyledButton.vue';
import { useAutoDelivery } from '@/stores/autoDelivery';

defineEmits(['learn-more']);

const { autoDeliveryChannel } = useAutoDelivery();
</script>

<template>
  <div>
    <div
      class="flex flex-col items-start gap-2 p-4 rounded bg-nuts-neutral-100"
      data-test="auto-delivery-benefits"
    >
      <UnstyledButton tabindex="-1" @click="$emit('learn-more')">
        <BaseBodyText class="font-semibold underline text-nuts-lime-900">
          Auto-Delivery Benefits:
        </BaseBodyText>
      </UnstyledButton>
      <ul class="flex flex-col gap-1">
        <li class="flex items-center gap-1.5">
          <CheckIcon class="text-nuts-lime-900" :size="16" />
          <SmallBodyText class="text-nuts-lime-900">
            Easy to pause, edit & cancel anytime!
          </SmallBodyText>
        </li>
        <li class="flex items-center gap-1.5">
          <CheckIcon class="text-nuts-lime-900" :size="16" />
          <SmallBodyText class="text-nuts-lime-900">
            Choose the quantity and frequency that work best for you!
          </SmallBodyText>
        </li>
        <li class="flex items-center gap-1.5">
          <CheckIcon class="text-nuts-lime-900" :size="16" />
          <SmallBodyText class="text-nuts-lime-900">
            Get a {{ autoDeliveryChannel.discount }}% discount on every order!
          </SmallBodyText>
        </li>
      </ul>
      <UnstyledButton
        data-promo="1"
        data-promo-creative="Learn more: Auto-Delivery"
        data-promo-name="Infographic"
        data-test="learn-more-link"
        @click="$emit('learn-more')"
      >
        <SmallBodyText class="underline text-nuts-lime-900">Learn more</SmallBodyText>
      </UnstyledButton>
    </div>
  </div>
</template>

<style scoped>
p {
  @apply mb-0;
}
</style>
